import React, { useState, useEffect } from 'react';
import api from '../api';

function StaffManagement() {
  const [staffData,   setStaffData]   = useState(null);
  const [loading,     setLoading]     = useState(true);
  const [message,     setMessage]     = useState('');
  const [error,       setError]       = useState('');
  const [isPremium,   setIsPremium]   = useState(false);

  // Create modal
  const [showCreate,  setShowCreate]  = useState(false);
  const [createForm,  setCreateForm]  = useState({
    name:'', email:'', password:'', phone:'', role:'staff'
  });
  const [createLoading, setCreateLoading] = useState(false);

  // ✅ Edit modal
  const [showEdit,    setShowEdit]    = useState(false);
  const [editStaff,   setEditStaff]   = useState(null);
  const [editForm,    setEditForm]    = useState({
    name:'', phone:'', role:'staff'
  });
  const [editLoading, setEditLoading] = useState(false);

  // ✅ Reset password modal
  const [showReset,   setShowReset]   = useState(false);
  const [resetStaff,  setResetStaff]  = useState(null);
  const [newPassword, setNewPassword] = useState('');
  const [confirmPwd,  setConfirmPwd]  = useState('');
  const [resetLoading,setResetLoading]= useState(false);

  useEffect(() => {
    loadData();
    api.get('/auth/me').then(r => {
      const plan = r.data.account_type || 'pro';
      setIsPremium(plan === 'premium' || plan === 'business');
    }).catch(() => {});
  }, []);

  const loadData = async () => {
    setLoading(true);
    try {
      const res = await api.get('/auth/staff/list');
      setStaffData(res.data);
    } catch(err) {
      setError(err.response?.data?.detail || 'Load failed!');
    } finally { setLoading(false); }
  };

  const showMsg = (m, isErr=false) => {
    if(isErr){setError(m);setTimeout(()=>setError(''),4000);}
    else{setMessage(m);setTimeout(()=>setMessage(''),3000);}
  };

  // ── Create Staff ──────────────────────────────────
  const createStaff = async () => {
    if (!createForm.name || !createForm.email || !createForm.password) {
      showMsg('எல்லா fields-ம் fill பண்ணுங்கள்!', true); return;
    }
    if (createForm.password.length < 6) {
      showMsg('Password minimum 6 characters!', true); return;
    }
    setCreateLoading(true);
    try {
      await api.post('/auth/staff/create', createForm);
      showMsg(`✅ ${createForm.name} staff account created!`);
      setCreateForm({name:'',email:'',password:'',phone:'',role:'staff'});
      setShowCreate(false);
      loadData();
    } catch(err) {
      showMsg(err.response?.data?.detail || 'Create failed!', true);
    } finally { setCreateLoading(false); }
  };

  // ── ✅ Edit Staff ──────────────────────────────────
  const openEdit = (staff) => {
    setEditStaff(staff);
    setEditForm({
      name:  staff.name,
      phone: staff.phone || '',
      role:  staff.role  || 'staff',
    });
    setShowEdit(true);
  };

  const saveEdit = async () => {
    if (!editForm.name.trim()) {
      showMsg('Name required!', true); return;
    }
    setEditLoading(true);
    try {
      await api.put(`/auth/staff/${editStaff.id}/edit`, null, {
        params: {
          name:  editForm.name,
          phone: editForm.phone,
          role:  editForm.role,
        }
      });
      showMsg(`✅ ${editForm.name} updated!`);
      setShowEdit(false);
      setEditStaff(null);
      loadData();
    } catch(err) {
      showMsg(err.response?.data?.detail || 'Edit failed!', true);
    } finally { setEditLoading(false); }
  };

  // ── ✅ Reset Password ──────────────────────────────
  const openReset = (staff) => {
    setResetStaff(staff);
    setNewPassword('');
    setConfirmPwd('');
    setShowReset(true);
  };

  const saveReset = async () => {
    if (!newPassword) {
      showMsg('Password enter பண்ணுங்கள்!', true); return;
    }
    if (newPassword.length < 6) {
      showMsg('Minimum 6 characters!', true); return;
    }
    if (newPassword !== confirmPwd) {
      showMsg('Passwords match ஆகவில்லை!', true); return;
    }
    setResetLoading(true);
    try {
      await api.put(`/auth/staff/${resetStaff.id}/reset-password`, null, {
        params: { new_password: newPassword }
      });
      showMsg(`✅ ${resetStaff.name} password reset!`);
      setShowReset(false);
      setResetStaff(null);
    } catch(err) {
      showMsg(err.response?.data?.detail || 'Reset failed!', true);
    } finally { setResetLoading(false); }
  };

  // ── Remove / Restore ──────────────────────────────
  const removeStaff = async (staffId, staffName) => {
    if (!window.confirm(`${staffName} access remove பண்ணவா?`)) return;
    try {
      await api.delete(`/auth/staff/${staffId}`);
      showMsg(`✅ ${staffName} access removed!`);
      loadData();
    } catch(err) {
      showMsg(err.response?.data?.detail || 'Remove failed!', true);
    }
  };

  const restoreStaff = async (staffId, staffName) => {
    try {
      await api.put(`/auth/staff/${staffId}/restore`);
      showMsg(`✅ ${staffName} access restored!`);
      loadData();
    } catch(err) {
      showMsg(err.response?.data?.detail || 'Restore failed!', true);
    }
  };

  // ── Not Premium screen ────────────────────────────
  if (!isPremium) {
    return (
      <div style={S.page}>
        <div style={S.upgradeCard}>
          <div style={{fontSize:'48px',marginBottom:'16px'}}>👑</div>
          <h2 style={{color:'#2C3E50',margin:'0 0 8px'}}>Premium Feature!</h2>
          <p style={{color:'#666',marginBottom:'20px'}}>
            Staff Management = Premium/Business plan மட்டும்!
          </p>
          <div style={S.planRow}>
            {[
              {id:'pro',     name:'⭐ Pro',     price:299, users:'1 User',   col:'#3498DB'},
              {id:'premium', name:'👑 Premium', price:599, users:'3 Users ✅',col:'#C9A84C'},
              {id:'business',name:'🏢 Business',price:999, users:'5 Users ✅',col:'#9B59B6'},
            ].map(p=>(
              <div key={p.id} style={{
                ...S.planBox,
                border: p.id==='premium'?`2px solid ${p.col}`:'1px solid #EEE',
                background: p.id==='premium'?'#FFF9E6':'white',
              }}>
                <div style={{fontWeight:'700',color:p.col}}>{p.name}</div>
                <div style={{fontSize:'12px',color:'#666',margin:'4px 0'}}>{p.users}</div>
                <div style={{fontSize:'20px',fontWeight:'900',color:'#2C3E50'}}>
                  Rs.{p.price}
                </div>
              </div>
            ))}
          </div>
          <button style={S.upgradeBtn}
            onClick={()=>window.location.href='/trial-expired'}>
            👑 Premium Upgrade பண்ணுங்கள்!
          </button>
        </div>
      </div>
    );
  }

  if (loading) return (
    <div style={S.page}><p style={{color:'#666',textAlign:'center'}}>⏳ Loading...</p></div>
  );

  return (
    <div style={S.page}>
      <h1 style={S.title}>👥 Staff Management</h1>

      {/* Plan info bar */}
      {staffData && (
        <div style={S.planBar}>
          <div style={{display:'flex',alignItems:'center',gap:'12px'}}>
            <span style={{fontSize:'20px'}}>👑</span>
            <div>
              <div style={{fontWeight:'700',color:'#2C3E50'}}>{staffData.plan}</div>
              <div style={{fontSize:'12px',color:'#888'}}>
                {staffData.slots_used}/{staffData.max_users} users |
                {staffData.slots_left > 0
                  ? ` ${staffData.slots_left} slots left`
                  : ' Limit reached!'}
              </div>
            </div>
          </div>
          {staffData.slots_left > 0 && (
            <button style={S.addBtn} onClick={()=>setShowCreate(true)}>
              ➕ Add Staff
            </button>
          )}
        </div>
      )}

      {/* Messages */}
      {message && <div style={S.successBox}>{message}</div>}
      {error   && <div style={S.errorBox}>{error}</div>}

      {/* Owner card */}
      <div style={S.section}>
        <h3 style={S.sectionTitle}>👤 Owner (You)</h3>
        <div style={S.ownerCard}>
          <span style={{fontSize:'24px'}}>👑</span>
          <div style={{flex:1}}>
            <div style={{fontWeight:'700',color:'#2C3E50'}}>{staffData?.owner}</div>
            <div style={{fontSize:'12px',color:'#888'}}>Owner — Full access</div>
          </div>
          <span style={{...S.badge,background:'#E8F8F0',color:'#27AE60'}}>Active</span>
        </div>
      </div>

      {/* Staff list */}
      <div style={S.section}>
        <h3 style={S.sectionTitle}>
          Staff Accounts ({staffData?.staff?.length || 0})
        </h3>

        {(!staffData?.staff || staffData.staff.length === 0) ? (
          <div style={S.emptyBox}>
            <div style={{fontSize:'32px',marginBottom:'8px'}}>👥</div>
            <p style={{color:'#888',margin:0}}>
              Staff இல்லை! "Add Staff" click பண்ணுங்கள்!
            </p>
          </div>
        ) : (
          staffData.staff.map(staff => (
            <div key={staff.id} style={{
              ...S.staffCard,
              opacity: staff.is_active ? 1 : 0.6,
            }}>
              {/* Staff icon */}
              <span style={{fontSize:'24px'}}>
                {staff.role==='cashier'?'💰':
                 staff.role==='viewer' ?'👁️':'👤'}
              </span>

              {/* Staff info */}
              <div style={{flex:1}}>
                <div style={{
                  fontWeight:'700',color:'#2C3E50',fontSize:'15px',
                }}>
                  {staff.name}
                  {!staff.is_active && (
                    <span style={{color:'#E74C3C',fontSize:'11px',marginLeft:'8px'}}>
                      (Disabled)
                    </span>
                  )}
                </div>
                <div style={{fontSize:'12px',color:'#666'}}>{staff.email}</div>
                {staff.phone && (
                  <div style={{fontSize:'12px',color:'#888'}}>📱 {staff.phone}</div>
                )}
                <span style={{
                  display:'inline-block',marginTop:'4px',
                  padding:'2px 8px',borderRadius:'10px',fontSize:'11px',
                  fontWeight:'700',
                  background: staff.role==='cashier'?'#EBF5FB':
                               staff.role==='viewer' ?'#F3E5F5':'#E8F8F0',
                  color: staff.role==='cashier'?'#3498DB':
                          staff.role==='viewer' ?'#9B59B6':'#27AE60',
                }}>
                  {staff.role}
                </span>
              </div>

              {/* ✅ Action buttons */}
              <div style={{display:'flex',gap:'6px',flexWrap:'wrap',justifyContent:'flex-end'}}>
                {/* Edit button */}
                {staff.is_active && (
                  <button style={S.btnEdit}
                    onClick={()=>openEdit(staff)}>
                    ✏️ Edit
                  </button>
                )}
                {/* Reset password */}
                {staff.is_active && (
                  <button style={S.btnReset}
                    onClick={()=>openReset(staff)}>
                    🔑 Password
                  </button>
                )}
                {/* Remove / Restore */}
                {staff.is_active ? (
                  <button style={S.btnRemove}
                    onClick={()=>removeStaff(staff.id,staff.name)}>
                    🚫 Remove
                  </button>
                ) : (
                  <button style={S.btnRestore}
                    onClick={()=>restoreStaff(staff.id,staff.name)}>
                    ✅ Restore
                  </button>
                )}
              </div>
            </div>
          ))
        )}
      </div>

      {/* Help box */}
      <div style={S.helpBox}>
        <h4 style={{margin:'0 0 10px',color:'#2C3E50'}}>📋 Staff Access Guide</h4>
        {[
          ['👤 Staff',   'Items, Bills, Customers, Suppliers — Full access'],
          ['💰 Cashier', 'Bills only — Cannot add/edit items'],
          ['👁️ Viewer',  'View only — Cannot create/edit anything'],
        ].map(([role,desc])=>(
          <div key={role} style={{fontSize:'13px',color:'#555',margin:'6px 0',
            display:'flex',gap:'8px'}}>
            <span style={{fontWeight:'700',minWidth:'80px'}}>{role}</span>
            <span>{desc}</span>
          </div>
        ))}
        <p style={{fontSize:'12px',color:'#E74C3C',margin:'10px 0 0',fontWeight:'600'}}>
          ⚠️ Staff = Admin panel access இல்லை!
        </p>
      </div>

      {/* ── Create Modal ── */}
      {showCreate && (
        <div style={S.overlay}
          onClick={e=>e.target===e.currentTarget&&setShowCreate(false)}>
          <div style={S.modal}>
            <h2 style={S.modalTitle}>➕ New Staff Account</h2>
            {[
              {label:'Staff Name *',     key:'name',     type:'text',     ph:'Staff பெயர்'},
              {label:'Email *',          key:'email',    type:'email',    ph:'staff@email.com'},
              {label:'Password *',       key:'password', type:'password', ph:'Minimum 6 chars'},
              {label:'Phone',            key:'phone',    type:'tel',      ph:'Mobile number'},
            ].map(f=>(
              <div key={f.key}>
                <label style={S.label}>{f.label}</label>
                <input style={S.input}
                  type={f.type} placeholder={f.ph}
                  value={createForm[f.key]}
                  onChange={e=>setCreateForm({...createForm,[f.key]:e.target.value})}/>
              </div>
            ))}
            <label style={S.label}>Role</label>
            <select style={S.input}
              value={createForm.role}
              onChange={e=>setCreateForm({...createForm,role:e.target.value})}>
              <option value="staff">👤 Staff (Full access)</option>
              <option value="cashier">💰 Cashier (Bills only)</option>
              <option value="viewer">👁️ Viewer (View only)</option>
            </select>
            <div style={S.infoBox}>
              ℹ️ Staff login = உங்கள் shop data shared!
            </div>
            <div style={S.modalBtns}>
              <button style={S.cancelBtn} onClick={()=>setShowCreate(false)}>
                Cancel
              </button>
              <button style={{...S.confirmBtn,opacity:createLoading?0.6:1}}
                onClick={createStaff} disabled={createLoading}>
                {createLoading?'⏳ Creating...':'✅ Create Staff'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ── ✅ Edit Modal ── */}
      {showEdit && editStaff && (
        <div style={S.overlay}
          onClick={e=>e.target===e.currentTarget&&setShowEdit(false)}>
          <div style={S.modal}>
            <h2 style={S.modalTitle}>✏️ Edit Staff — {editStaff.name}</h2>
            <p style={{fontSize:'13px',color:'#888',marginBottom:'16px'}}>
              Email: {editStaff.email}
            </p>

            <label style={S.label}>Name *</label>
            <input style={S.input}
              placeholder="Staff பெயர்"
              value={editForm.name}
              onChange={e=>setEditForm({...editForm,name:e.target.value})}/>

            <label style={S.label}>Phone</label>
            <input style={S.input}
              type="tel" placeholder="Mobile number"
              value={editForm.phone}
              onChange={e=>setEditForm({...editForm,phone:e.target.value})}/>

            <label style={S.label}>Role</label>
            <select style={S.input}
              value={editForm.role}
              onChange={e=>setEditForm({...editForm,role:e.target.value})}>
              <option value="staff">👤 Staff (Full access)</option>
              <option value="cashier">💰 Cashier (Bills only)</option>
              <option value="viewer">👁️ Viewer (View only)</option>
            </select>

            <div style={S.modalBtns}>
              <button style={S.cancelBtn} onClick={()=>setShowEdit(false)}>
                Cancel
              </button>
              <button style={{...S.confirmBtn,opacity:editLoading?0.6:1}}
                onClick={saveEdit} disabled={editLoading}>
                {editLoading?'⏳ Saving...':'💾 Save Changes'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ── ✅ Reset Password Modal ── */}
      {showReset && resetStaff && (
        <div style={S.overlay}
          onClick={e=>e.target===e.currentTarget&&setShowReset(false)}>
          <div style={S.modal}>
            <h2 style={S.modalTitle}>🔑 Reset Password — {resetStaff.name}</h2>
            <p style={{fontSize:'13px',color:'#888',marginBottom:'16px'}}>
              Email: {resetStaff.email}
            </p>

            <label style={S.label}>New Password *</label>
            <input style={S.input}
              type="password" placeholder="Minimum 6 characters"
              value={newPassword}
              onChange={e=>setNewPassword(e.target.value)}/>

            <label style={S.label}>Confirm Password *</label>
            <input style={S.input}
              type="password" placeholder="Again type பண்ணுங்கள்"
              value={confirmPwd}
              onChange={e=>setConfirmPwd(e.target.value)}/>

            {newPassword && confirmPwd && newPassword !== confirmPwd && (
              <p style={{color:'#E74C3C',fontSize:'12px',margin:'4px 0'}}>
                ❌ Passwords match ஆகவில்லை!
              </p>
            )}
            {newPassword && confirmPwd && newPassword === confirmPwd && (
              <p style={{color:'#27AE60',fontSize:'12px',margin:'4px 0'}}>
                ✅ Passwords match!
              </p>
            )}

            <div style={S.infoBox}>
              ⚠️ Password reset பண்ணினால் staff-க்கு
              புது password share பண்ணுங்கள்!
            </div>

            <div style={S.modalBtns}>
              <button style={S.cancelBtn} onClick={()=>setShowReset(false)}>
                Cancel
              </button>
              <button style={{...S.confirmBtn,
                background:'#E67E22',
                opacity:resetLoading?0.6:1}}
                onClick={saveReset} disabled={resetLoading}>
                {resetLoading?'⏳ Resetting...':'🔑 Reset Password'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const S = {
  page:        {padding:'20px',maxWidth:'720px',margin:'0 auto'},
  title:       {color:'#2C3E50',marginBottom:'20px'},
  upgradeCard: {textAlign:'center',background:'white',borderRadius:'16px',
                padding:'40px',boxShadow:'0 4px 20px rgba(0,0,0,0.1)'},
  planRow:     {display:'flex',gap:'12px',justifyContent:'center',margin:'16px 0 24px',flexWrap:'wrap'},
  planBox:     {borderRadius:'10px',padding:'14px 18px',textAlign:'center',minWidth:'100px'},
  upgradeBtn:  {background:'#C9A84C',color:'#2C3E50',border:'none',
                padding:'13px 28px',borderRadius:'10px',fontSize:'15px',
                fontWeight:'700',cursor:'pointer'},
  planBar:     {display:'flex',justifyContent:'space-between',alignItems:'center',
                background:'#FFF9E6',border:'2px solid #C9A84C',
                borderRadius:'12px',padding:'14px 18px',marginBottom:'20px'},
  addBtn:      {background:'#27AE60',color:'white',border:'none',
                padding:'10px 20px',borderRadius:'8px',cursor:'pointer',
                fontSize:'14px',fontWeight:'700'},
  successBox:  {background:'#E8F8F0',border:'1px solid #27AE60',color:'#27AE60',
                padding:'10px 14px',borderRadius:'8px',marginBottom:'14px',fontWeight:'600'},
  errorBox:    {background:'#FFF0F0',border:'1px solid #E74C3C',color:'#E74C3C',
                padding:'10px 14px',borderRadius:'8px',marginBottom:'14px'},
  section:     {background:'white',borderRadius:'12px',padding:'20px',
                border:'1px solid #EEE',marginBottom:'16px'},
  sectionTitle:{color:'#2C3E50',margin:'0 0 14px',fontSize:'15px'},
  ownerCard:   {display:'flex',alignItems:'center',gap:'12px',
                background:'#FFF9E6',borderRadius:'10px',padding:'14px',
                border:'1px solid #C9A84C'},
  staffCard:   {display:'flex',alignItems:'center',gap:'12px',
                background:'#F8F9FA',borderRadius:'10px',padding:'14px',
                border:'1px solid #EEE',marginBottom:'10px'},
  badge:       {padding:'4px 10px',borderRadius:'20px',fontSize:'11px',fontWeight:'700'},
  emptyBox:    {textAlign:'center',padding:'30px',color:'#888',
                background:'#F8F9FA',borderRadius:'10px'},
  helpBox:     {background:'#F8F9FA',borderRadius:'12px',
                padding:'16px',border:'1px solid #EEE'},
  // Action buttons
  btnEdit:     {background:'#3498DB',color:'white',border:'none',
                padding:'6px 12px',borderRadius:'6px',cursor:'pointer',
                fontSize:'12px',fontWeight:'700'},
  btnReset:    {background:'#E67E22',color:'white',border:'none',
                padding:'6px 12px',borderRadius:'6px',cursor:'pointer',
                fontSize:'12px',fontWeight:'700'},
  btnRemove:   {background:'#E74C3C',color:'white',border:'none',
                padding:'6px 12px',borderRadius:'6px',cursor:'pointer',
                fontSize:'12px',fontWeight:'700'},
  btnRestore:  {background:'#27AE60',color:'white',border:'none',
                padding:'6px 12px',borderRadius:'6px',cursor:'pointer',
                fontSize:'12px',fontWeight:'700'},
  // Modal
  overlay:     {position:'fixed',inset:0,background:'rgba(0,0,0,0.6)',
                zIndex:2000,display:'flex',alignItems:'center',
                justifyContent:'center',padding:'20px'},
  modal:       {background:'white',borderRadius:'16px',padding:'28px',
                maxWidth:'440px',width:'100%',
                boxShadow:'0 20px 60px rgba(0,0,0,0.3)',
                maxHeight:'90vh',overflowY:'auto'},
  modalTitle:  {margin:'0 0 14px',color:'#2C3E50',fontSize:'18px'},
  label:       {display:'block',fontSize:'11px',fontWeight:'700',color:'#666',
                marginBottom:'4px',marginTop:'12px',textTransform:'uppercase'},
  input:       {display:'block',width:'100%',padding:'10px 12px',
                borderRadius:'8px',border:'1px solid #DDD',fontSize:'14px',
                boxSizing:'border-box',background:'white'},
  infoBox:     {background:'#EBF5FB',border:'1px solid #3498DB',
                borderRadius:'8px',padding:'10px 14px',
                marginTop:'12px',fontSize:'12px',color:'#2C3E50'},
  modalBtns:   {display:'flex',gap:'10px',marginTop:'20px'},
  cancelBtn:   {flex:1,padding:'11px',borderRadius:'8px',
                border:'1px solid #DDD',background:'white',
                cursor:'pointer',fontWeight:'600',color:'#555'},
  confirmBtn:  {flex:2,padding:'11px',borderRadius:'8px',border:'none',
                background:'#27AE60',color:'white',cursor:'pointer',
                fontWeight:'700',fontSize:'14px'},
};

export default StaffManagement;

